import React, { useEffect } from 'react';
import $ from "jquery";
import Toastr from 'toastr';
import Hls from 'hls.js';
import logo from '../../assets/img/sitekick-header-logo.png';
import Loading from "../Loading";
import bootbox from 'bootbox';
import '../../assets/css/videojs.css';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

let player;
function LegacyLiveStream(props) {
    const { stream_token } = props;
    //const [dataEndPoint, setDataEndPoint] = useState(null);
    const browserAgent = navigator.userAgent.toUpperCase();
    const iOS = browserAgent.includes('IPAD') || browserAgent.includes('IPHONE');
    const video_hls_id = 'legacy-video';
    const waitTimeForExtendTimer = 1 * 60 * 1000;
    const legacyCameraMaxStreamSession = 5 * 60 * 1000;

    useEffect(() => {
        startLiveCameraFeed();
    }, []);

    const manageCameraFeed = async (operation, extraAtts = {}) => {
        const data = {
            user_login: stream_token.user_login,
            user_token: stream_token.user_token,
            form_input: { operation, device_id: stream_token.device_id, ...extraAtts }
        };

        try {
            const res = await CommonUtils.ajax({
                url: API.CAMERA.LIVE_FEED,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            });

            if (res.status && (res.status.code === 200 || res.status.code === 201)) {
                return res.data;
            }
        } catch (error) {
            console.error(error);
        }

        return null;
    };

    const startLiveCameraFeed = async () => {
        const deviceState = await manageCameraFeed('start-feed');
        if (deviceState && deviceState.payload) {
            let cameraFeed;
            let attempts = 20;
            while (!cameraFeed && attempts > 0) {
                cameraFeed = await manageCameraFeed('stream-url');
                if (cameraFeed && cameraFeed.code === 'ResourceNotFoundException') {
                    attempts = 0;
                } else {
                    if (!cameraFeed || !cameraFeed.HLSStreamingSessionURL) {
                        cameraFeed = null;
                        await sleep(5000);
                    }
                    attempts--;
                }
            }

            if (cameraFeed) {
                if (cameraFeed.code === 'ResourceNotFoundException') {
                    Toastr.error('No active LIVE feed available ...');
                } else {
                    //const DataEndpoint = cameraFeed.endpoint;
                    //setDataEndPoint(DataEndpoint);
                    playHLSVideo(cameraFeed.HLSStreamingSessionURL);
                }
            } else {
                Toastr.error('Unable to retrieve LIVE feed ...');
            }
        } else {
            Toastr.error('No LIVE feed available');
        }
    };



    const startTimer = () => {
        setTimeout(() => {
            setTimeout(() => {
                window.location = 'https://www.sitekick.com';
            }, waitTimeForExtendTimer);

            bootbox.dialog({
                html: true,
                closeButton: false,
                message: "Would you like to continue viewing this stream ? <br><small class='text-danger'>Stops stream if there’s no response within a minute.</small>",
                buttons: {
                    cancel: {
                        label: 'No',
                        className: 'btn btn-sm btn-default close-device-lock-bb',
                        callback: function (isYes) {
                            window.location = 'https://www.sitekick.com';
                        }
                    },
                    confirm: {
                        label: 'Extend Timer',
                        className: 'btn btn-sm btn-success',
                        callback: function (isYes) {
                            window.location.reload();
                        }
                    }
                }
            });
        }, legacyCameraMaxStreamSession);
    }

    const playHLSVideo = async (stream_url) => {
        const video = document.getElementById(video_hls_id);
        if (Hls.isSupported()) {
            const hls = new Hls({
                debug: true,
            });
            hls.loadSource(stream_url);
            hls.attachMedia(video);
            hls.on(Hls.Events.MEDIA_ATTACHED, function () {
                video.muted = true;
                video.play();
                startTimer();
            });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            if (!window.videojs)
                return setTimeout(playHLSVideo(stream_url), 3000);

            player = window.videojs('#' + video_hls_id);
            setTimeout(() => {
                player.ready(function () {
                    this.src({
                        src: stream_url,
                        type: 'application/x-mpegURL'
                    });
                    $('#' + video_hls_id).removeClass('hide');
                    $('#' + video_hls_id + ' .vjs-big-play-button').trigger('click');
                    startTimer();
                });
            }, iOS ? 5000 : 0);
        }
    };

    // const stopVideo = async () => {
    //     try {
    //         if (player) {
    //             player.dispose();
    //         }
    //     } catch (e) { }
    //     await manageCameraFeed('stop-feed');
    // };

    // const saveClip = async () => {
    //     Toastr.success('Saving in progress...');
    //     $('.save-clip').prop('disabled', true);
    //     const extraAtts = {
    //         DataEndpoint: dataEndPoint,
    //         customer_id: stream_token.customer_id,
    //         site_id: stream_token.site_id,
    //         location_id: stream_token.location_id
    //     };
    //     const result = await manageCameraFeed('save-clip', extraAtts);
    //     if (result) {
    //         closeWindow();
    //         Toastr.success('Video is saved and available in the video library.');
    //     } else {
    //         closeWindow();
    //         Toastr.error('Error while saving video ...');
    //     }
    // };

    const sleep = async (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    };

    return <>
        <div id="video-container">
            <a href='https://www.sitekick.com' target='_blank' rel="noopener noreferrer" className="bg-primary go-to-sitekick" style={{ position: 'fixed', zIndex: 1000, top: '10px', right: '10px', borderRadius: '2px', padding: '3px 0px 0px 4px' }}>
                <img className="pb-1" src={logo} alt="logo" style={{ width: "95px", marginRight: "10px" }} />
            </a>
            <div className="ant-modal-mask stream-mask d-flex justify-content-center" ><span className="align-self-center"><Loading >Loading ...</Loading></span></div>
            <video onPlay={() => { $(".stream-mask").addClass("hide"); $("#legacy-video").width($("body").innerWidth()); }} id="legacy-video" autoPlay muted playsInline controls style={{ "maxWidth": "100%", "maxHeight": "100%" }} ></video>
        </div>
    </>
}

export default LegacyLiveStream;